import { useAuthStore } from "../stores";
import { BriefcaseBusiness, Calculator, Camera, ClipboardMinus, Contact, Layers, Truck, User, Users } from "lucide-react";

export const useSidebar = () => {

  const user = useAuthStore((state) => state.currentUser);
  const evaluation = useAuthStore((state) => state.evaluation);

  const sidebarBase = [
    { icon: <User size={22} />, label: "Perfil", key: "profile", path: "/dashboard/profile", hiddenRoles: ["admin", "superAdmin", "odt_viewer"], allowedRoles: ["*"] },
    { icon: <BriefcaseBusiness size={22} />, label: "ODTs", key: "odts", path: "/dashboard/odts", hiddenRoles: ["admin_logistics", "warehouse", "leave_warehouse"], allowedRoles: ["*"] },
    { icon: <Layers size={22} />, label: "Tercerización", key: "outsourcing", path: "/dashboard/outsourcing", hiddenRoles: ["admin_logistics", "admin_odt", "warehouse", "leave_warehouse", "purchase", "cut", "decoration", "sewing", "packing", "odt_viewer"], allowedRoles: ["*"] },
    { icon: <Truck size={22} />, label: "Logística", key: "logistic", path: "/dashboard/logistic", hiddenRoles: null, allowedRoles: ["superAdmin", "admin", "admin_logistics", "warehouse", "leave_warehouse"] },
    { icon: <Calculator size={22} />, label: "Contabilidad", key: "accounting", path: "/dashboard/accounting", hiddenRoles: null, allowedRoles: ["superAdmin", "admin", "accounting_admin"] },
    { icon: <ClipboardMinus size={22} />, label: "Recursos Humanos", key: "humanResources", path: "/dashboard/human-resources", hiddenRoles: null, allowedRoles: ["superAdmin", "admin"] },
    { icon: <Camera size={22} />, label: "Asistencia Diaria", key: "dailyCheck", path: "/dashboard/daily-check", hiddenRoles: ["admin", "superAdmin", "odt_viewer"], allowedRoles: ["*"] },
    { icon: <Contact size={22} />, label: "Usuarios", key: "contact", path: "/dashboard/users", hiddenRoles: null, allowedRoles: ["superAdmin"] },
  ];

  // If the logged user doesn't have evaluation=true, hide the dailyCheck item
  const sidebar = sidebarBase.filter((item) => {
    if (item.key === "dailyCheck" && evaluation === false) return false;
    return true;
  });

  const validateRol = (item: typeof sidebar[number]): boolean => {
    const userArea = Array.isArray(user.area) ? user.area[0] : user.area;

    if (item.hiddenRoles && item.hiddenRoles.includes(userArea)) return false;
    if ((item.allowedRoles && item.allowedRoles.includes(userArea)) || item.allowedRoles?.includes("*")) return true;
    return false;
  };

  return { sidebar, validateRol };
}